<app-menu></app-menu>
<mat-toolbar color="primary"> Status of static image packs </mat-toolbar>
<div style="margin: auto">
  <mat-card>
    <mat-card-content>
      <mat-card class="mat-elevation-z0 card-padding">
        <form [formGroup]="filterForm">
        <div>
          <mat-label class="col-sm-1">Static Image Pack</mat-label>
          <mat-form-field class="col-sm-2">
            <input matInput class="form-field" [formControl]="filenameFilter" placeholder="Enter search term">
          </mat-form-field>
          <mat-label class="col-sm-1">Uploaded from - to</mat-label>
          <mat-form-field class="col-sm-2">
            <input
              matInput
              [matDatepicker]="fromDate"
              placeholder="From Date"
              formControlName="fromDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="fromDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #fromDate></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-sm-2">
            <input
              matInput
              [matDatepicker]="toDate"
              placeholder="To Date"
              formControlName="toDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="toDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #toDate></mat-datepicker>
          </mat-form-field>
          <button mat-raised-button color="accent" (click)="reset()">
            Reset
          </button>
        </div>
      </form>
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let row">{{ row.status }}</td>
          </ng-container>
          <ng-container matColumnDef="lastModifiedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload</th>
            <td mat-cell *matCellDef="let row">{{ row.lastModifiedDate | date: "medium":"+0200":"de" }}</td>
          </ng-container>
          <ng-container matColumnDef="fileName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Static Image Pack
            </th>
            <td mat-cell *matCellDef="let row">{{ row.fileName }}</td>
          </ng-container>
          <ng-container matColumnDef="lastPreprodPromoteDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              last Promotion to Pre-Prod
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.lastPreprodPromoteDate | date: "medium":"+0200":"de" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lastProdPromoteDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              last Promotion to Prod
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.lastProdPromoteDate | date: "medium":"+0200":"de" }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">
              No data matching the filters
            </td>
          </tr>
        </table>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
